import { Link } from '@tanstack/react-router';
import { getResultsSummary } from "@/utils/listing-utils.ts"
import type { GroupedSearchResults, SearchResult } from "@/types/types.ts"

interface ResultsProps {
    data: GroupedSearchResults,
    currentPage: number
}

/**
 * The results for the Policy Library Listing.
 * Appears when the data from the Confluence search endpoint has been loaded.
 */
export default function Results({data, currentPage}: ResultsProps) {
    if (!data) return;

    const content = data?.results;

 if (Object.keys(content).length === 0) return (
     <h3 className="no-results">No results.</h3>
 )

 return (
     <>
         <p className="results-summary" aria-live="polite">
             {getResultsSummary({
                 currentPage,
                 limit: data.limit,
                 size: data.size,
                 totalSize: data.totalSize,
             })}
         </p>
         {Object.entries(content).map(([letter, results]) => (
             <div key={letter} className="letter-group">
                <div className="letter-title"><h2>{letter}</h2></div>
                <div className="letter-results">
                     <ul>
                         {results.map((result: SearchResult) => (
                             <li key={result.content.id}>
                                 <h3>
                                     <Link to="/policy/$pageId"
                                           params={{pageId: result.content.id}}>{result.content.title}</Link>
                                 </h3>
                             </li>
                             ))}
                     </ul>
                 </div>
             </div>
             ))}
     </>
 )
}